/* globals Vue, CardSlider */

import OfferCard from './OfferCard'

export default {
  name: 'OfferSlider',
  components: { OfferCard },
  template: `
  <div ref="sliderRef" class="card-slider" :class="{
      ['card-slider--' + variant]: true,
      'no-padding-bottom card-slider--no-slider': offers.length <= 1,
      'card-slider--single': offers.length === 1,
      'card-slider--double': offers.length === 2 && variant !== 'full-width',
    }">
    <div class="container container--fluid">
      <div class="swiper">
        <div class="swiper-wrapper">
          <div v-for="(offer, index) in offers" class="swiper-slide">
            <OfferCard
              :offer="offer"
              :isWide="offers.length === 1 || variant === 'full-width'"
              :isMiddle="offers.length === 2 && index === 0" />
          </div>
        </div>

        <div class="card-slider__navigation" v-if="offers.length > 1">
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>
    <div class="swiper-scrollbar" v-if="offers.length > 1"></div>
  </div>
  `,
  props: { offers: Array, variant: { type: String, default: 'default' } },
  setup (props) {
    const sliderRef = Vue.ref(null)
    const { offers } = Vue.toRefs(props)

    Vue.watch(offers, () => {
      Vue.nextTick(() => {
        CardSlider(sliderRef.value)
      })
    }, { immediate: true })

    return {
      sliderRef,
      offers,
    }
  },
}
